var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareUnicreditTowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -1308.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Unicredit-Towers",
    transform: "translate(3498.000000, 1308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3529586,0.5 C29.6229629,1.16940625 29.8739668,1.87853125 30.1049704,2.6215625 L30.1049704,2.6215625 L30.7539805,9.4880625 L31.7089955,9.4880625 C31.8979984,11.1533437 32,12.8990313 32,14.698 L32,14.698 L32,31.4709375 L31.6839951,31.4709375 L31.6839951,31.5 L21.7038391,31.5 L21.7038391,16.0649062 L20.3288176,15.624125 C18.173784,14.934375 15.9007484,14.3560312 13.5517117,13.8813437 C17.730777,12.6723437 22.336849,11.8198437 27.2509258,11.4371875 C27.3009266,10.780375 27.3519274,10.1235625 27.4239285,9.4880625 L27.4239285,9.4880625 L27.7869342,5.7874375 L28.2809419,5.7874375 L28.6009469,2.62253125 C28.8319505,1.8795 29.0829544,1.16940625 29.3529586,0.5 Z M-3.55271368e-15,14.3447937 C7.19911249,14.49495 13.9202175,15.6128875 19.6953077,17.4622312 L19.6953077,17.4622312 L19.6953077,31.4994187 L4.30406725,31.4994187 C1.92703011,31.4994187 -3.55271368e-15,29.642325 -3.55271368e-15,27.3512312 L-3.55271368e-15,27.3512312 Z",
    id: 59
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareUnicreditTowers);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-unicredit-towers.0a65c186.svg";
export { ForwardRef as ReactComponent };